import { ChangeDetectionStrategy, Component, InputSignal, OutputEmitterRef, input, output } from '@angular/core';

import { EntityItemsModule, EntityListHeadActionButtonComponent } from '@core/ui';
import { IndustryCatalogAssignment } from '@mp/content-manager/plattformkataloge/data-access';

import { FilterCatalogsByPipe } from './filter-catalogs-by.pipe';
import { SortableKatalogListComponent } from './sortable-katalog-list/sortable-katalog-list.component';

type SortItem = {
  id: string;
  previousIndex: number;
  currentIndex: number;
};

@Component({
  selector: 'mp-industry-catalogs-container',
  templateUrl: './industry-catalogs-container.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [EntityItemsModule, FilterCatalogsByPipe, SortableKatalogListComponent, EntityListHeadActionButtonComponent],
})
export class IndustryCatalogsContainerComponent {
  readonly catalogs: InputSignal<IndustryCatalogAssignment[]> = input.required<IndustryCatalogAssignment[]>();
  readonly allowSort: InputSignal<boolean> = input<boolean>(true);
  readonly allowNavigation = input(true);
  readonly searchTerm: InputSignal<string> = input<string>('');

  readonly addItemsClicked: OutputEmitterRef<(items: IndustryCatalogAssignment[]) => void> =
    output<(items: Array<IndustryCatalogAssignment>) => void>();
  readonly searched: OutputEmitterRef<string> = output<string>();
  readonly itemRemoved: OutputEmitterRef<IndustryCatalogAssignment> = output<IndustryCatalogAssignment>();
  readonly itemsAdded: OutputEmitterRef<IndustryCatalogAssignment[]> = output<IndustryCatalogAssignment[]>();
  readonly itemSorted: OutputEmitterRef<SortItem> = output<SortItem>();
  readonly industryCatalogClicked: OutputEmitterRef<string> = output<string>();

  emitItemRemoved(katalog: IndustryCatalogAssignment): void {
    this.itemRemoved.emit(katalog);
  }

  emitItemsAdded(kataloge: Array<IndustryCatalogAssignment>): void {
    this.itemsAdded.emit(kataloge);
  }

  emitItemSorted(event: { id: string; previousIndex: number; currentIndex: number }): void {
    this.itemSorted.emit(event);
  }

  emitSearched(searchTerm: string | undefined): void {
    this.searched.emit(searchTerm ?? '');
  }

  emitIndustriekatalogClicked(id: string): void {
    this.industryCatalogClicked.emit(id);
  }

  handleAddItemsClicked(): void {
    const resolver = (items: Array<IndustryCatalogAssignment>) => this.itemsAdded.emit(items);
    this.addItemsClicked.emit(resolver);
  }
}
